import { render, staticRenderFns } from "./AddProvRemRequest.vue?vue&type=template&id=3ffe2f0f"
import script from "./AddProvRemRequest.vue?vue&type=script&lang=js"
export * from "./AddProvRemRequest.vue?vue&type=script&lang=js"
import style0 from "./AddProvRemRequest.vue?vue&type=style&index=0&id=3ffe2f0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports